import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {MsalGuard} from "@azure/msal-angular";

const routes: Routes = [
	{
		path: '',
		pathMatch: 'full',
		redirectTo: 'home',
	},
	{
		path: 'home',
		canActivate: [MsalGuard],
		canActivateChild: [MsalGuard],
		loadChildren: () => import('./starter/starter.module').then(m => m.StarterModule)
	},
	{
		path: '**',
		redirectTo: '/denied',
	}
];

//When a new route is added/deleted/modified the 'nginx.conf' must be updated

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
